import React, { useEffect as uEffect } from 'react'

import { useState as uState } from "react";
import "../chart.scss";
import {
    BarChart,
    Bar,
    Legend,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from "recharts";


export default function productBarChart({ aspect, title }) {

    const [monthCount, setMonthCount] = uState('')
    const [monthCount2, setMonthCount2] = uState("");
    const [monthCount3, setMonthCount3] = uState("");
    const [monthCount4, setMonthCount4] = uState("");
    const [monthCount5, setMonthCount5] = uState("");
    const [monthCount6, setMonthCount6] = uState("");


    var currentDate = new Date(); // get the current date

    var dates = [];

    for (var i = 0; i < 6; i++) {
        // loop through the previous six months
        var previousMonth = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() - i
        ); // get the date object for the previous month
        var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        var previousMonthName = monthNames[previousMonth.getMonth()]; // get the name of the previous month
        var previousMonthYear = previousMonth.getFullYear(); // get the year of the previous month

        // if the previous month is in the previous year, subtract 1 from the year
        if (previousMonth.getMonth() > currentDate.getMonth()) {
            previousMonthYear -= 0;
        }

        var obj = { name: previousMonthName, Year: previousMonthYear }; // create an object with the name of the month and the year
        dates.push(obj); // add the object to the data array
    }


    const month1 = () => {
        fetch("http://localhost:8000/products/productMonthCount", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthCount(data));
    }
    const month2 = () => {
        fetch("http://localhost:8000/products/productMonthCount2", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthCount2(data));
    }
    const month3 = () => {
        fetch("http://localhost:8000/products/productMonthCount3", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthCount3(data));
    }
    const month4 = () => {
        fetch("http://localhost:8000/products/productMonthCount4", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthCount4(data));
    }
    const month5 = () => {
        fetch("http://localhost:8000/products/productMonthCount5", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthCount5(data));
    }
    const month6 = () => {
        fetch("http://localhost:8000/products/productMonthCount6", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ }),
        })
            .then((response) => response.json())
            .then((data) => setMonthCount6(data));
    }
    const fetchedData = [
        { name: dates[5].name, Year: dates[5].Year, Products: monthCount6 },
        { name: dates[4].name, Year: dates[4].Year, Products: monthCount5 },
        { name: dates[3].name, Year: dates[3].Year, Products: monthCount4 },
        { name: dates[2].name, Year: dates[2].Year, Products: monthCount3 },
        { name: dates[1].name, Year: dates[1].Year, Products: monthCount2 },
        { name: dates[0].name, Year: dates[0].Year, Products: monthCount },
    ];
    uEffect(() => {
        month1()
        month2()
        month3()
        month4()
        month5()
        month6()
    },[])




  return (
      <>
      
          <div className="chart">
              <div className="title">{title}</div>
                  <BarChart width={630} height={280} data={fetchedData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis dataKey="Products" />
                      <Tooltip />
                      <Legend />
                  <Bar dataKey="Products" fill="#046A38" />
                  </BarChart>
          </div>  
      
      
      </>
  )
}




